export const columns = [
  {
    title: 'No',
    key: 'row_id',
    headerClassName: 'column-no',
  },
  {
    title: 'URL',
    key: 'normalized_url',
    headerClassName: 'column-url',
  },
  {
    title: 'Category',
    key: 'original_category',
    headerClassName: 'column-category',
  },
  {
    title: 'Score',
    key: 'score',
    headerClassName: 'column-score',
  },
  {
    title: 'Tag',
    key: 'tag',
    headerClassName: 'column-category-tag',
  },
  {
    title: 'Prevalence Info',
    key: 'prevalence_info',
    headerClassName: 'column-prevalence-info',
  },
  {
    title: 'Last Updated',
    key: 'last_updated_timestamp',
    headerClassName: 'column-timestamp',
  }
];